export default {
  state: () => ({
    selectedCountry: undefined,
    countryOptions: undefined,
    cities: undefined,
  }),
  mutations: {
    setCountry(state, countryGeoId) {
      state.selectedCountry = countryGeoId;
    },
    setCountryOptions(state, countryOptions) {
      state.countryOptions = countryOptions;
    },
    addCities(state, cities) {
      if (state.cities === undefined) {
        state.cities = [];
      }
      state.cities = state.cities.concat(cities);
      // Sort the cities alphabetically.
      state.cities = state.cities.sort((a, b) => a.name.localeCompare(b.name));
    },
    resetCities(state) {
      state.cities = undefined;
    },
  },
  actions: {
    setCountry(context, countryGeoId) {
      context.commit('setCountry', countryGeoId);
    },
    setCountryOptions(context, countryOptions) {
      context.commit('setCountryOptions', countryOptions);
    },
    addCities(context, cities) {
      context.commit('addCities', cities);
    },
    resetCities(context) {
      context.commit('resetCities');
    },
  },
};
